<template>
  <div>
    <button
      v-focus
      class="collapse-header"
      :aria-expanded="isMenuOpen"
      aria-controls="collapse-content"
      @click.prevent="handleToggle"
    >
      <slot name="title"></slot>
      <transition name="rotate" mode="out-in">
        <i v-if="isMenuOpen" key="up" class="fa-solid fa-chevron-up"></i>
        <i v-else key="down" class="fa-solid fa-chevron-down"></i>
      </transition>
    </button>
    <div v-show="isMenuOpen" class="collapse-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup>
import { useToggleMenu } from "@follaw-fr/composables/useToggleMenu";

const props = defineProps({ startClosed: { type: Boolean, default: false } });
const emit = defineEmits(["open", "close"]);

const { isMenuOpen, toggleMenu, openMenu } = useToggleMenu();
if (!props.startClosed) openMenu();

const handleToggle = () => {
  toggleMenu();
  emit(isMenuOpen.value ? "open" : "close");
};
</script>

<style lang="scss" scoped>
.collapse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d1bfd9;
  margin: 10px 0 5px 0;
  padding-bottom: 5px;
  font-weight: 600;
  text-transform: capitalize;
  width: 100%;
  gap: 10px;
}

.collapse-content {
  display: flex;
  flex-direction: column;
}
</style>
